import { createMarketplaceEventFactory } from '../index';
import type {
  MarketplaceEventProps,
  MarketplaceEventSchema,
  PartialPick,
  RequiredPick,
} from '../properties';

export type InstallButtonClicked = MarketplaceEventSchema<
  RequiredPick<
    PartialPick<
      MarketplaceEventProps,
      | 'companyName'
      | 'embed'
      | 'inAppOrPublic'
      | 'hostApp'
      | 'listingId'
      | 'slug'
      | 'screen'
      | 'sourceId'
      | 'subscreen'
      | 'type'
    >,
    'type' | 'listingId' | 'sourceId'
  >
>;

export const getInstallButtonClickedEvent =
  createMarketplaceEventFactory<InstallButtonClicked>(
    'Marketplace',
    'Install Button Clicked'
  );
